<template>
    <div :class="classes">
        <a :href="mainWebsiteUrl">
            <picture>
                <source media="(min-resolution: 1.5dppx)"
                        :srcset="svgLogo">
                <img class="logo" :src="pngLogo" alt="Newport Logo">
            </picture>
        </a>
    </div>
</template>
<style lang="scss" scoped>
.logo-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    height: fit-content;
    z-index: 10;

    &.md,
    &.sm {
        justify-content: center;
    }
}
</style>
<script setup>
import { useAppStore } from '@stores/App';
import { computed, unref } from 'vue';

const props = defineProps({
    white: {
        type: Boolean,
        default: false,
    },
    society: {
        type: Boolean,
        default: false,
    },
    color: {
        type: Boolean,
        default: true,
    }
});

const app = useAppStore();

const classes = computed(() => {
    const cssWhite = props.white ? 'logo-white' : 'logo-black';
    return [ unref(app.getBreakpoints().active()), 'logo-wrapper', cssWhite ];
});

const mainWebsiteUrl = computed(() => {
    return app.getSalesChannelUrl();
});

const svgLogo = computed(() => {
    if (props.white) {
        return '/images/logos/newporthome-logo-full-white.svg';
    }

    if (props.color) {
        return '/images/logos/newport-color.svg';
    }

    if (props.society) {
        return '/images/logos/newport-society-black.svg';
    }

    return '/images/logos/newport-black.svg';
});

const pngLogo = computed(() => {
    if (props.white) {
        return '/images/logos/newporthome-logo-full-white.png';
    }

    if (props.color) {
        return '/images/logos/newport-logo.png';
    }

    if (props.society) {
        return '/images/logos/newport-society-black.png';
    }

    return '/images/logos/newport-black.svg';
});
</script>
